import Head from 'next/head'
import shopInfos from 'template/infos'
import type { LandingPageAboutPageSettings } from 'src/shared/dbTypes/landingPageSettings'

const { name, url } = shopInfos

interface Props {
  aboutPage?: LandingPageAboutPageSettings
}

const Seo: React.FC<Props> = ({ aboutPage }) => <Head>

  <title>{aboutPage?.metaTitle || `Über uns | ${name}`}</title>

  <meta name='description' content={
    aboutPage?.metaDescription
    || `Erfahren Sie mehr über ${name}.`
  } />

  <link rel='canonical' href={`${url}ueber-uns`} />

</Head>

export default Seo
